export class GlobalUser {
  public active: boolean = false;
  public userCode!: string;
  public socialMedia!: string;
  public name!: string;
  public nickName!: string;
  public birthday!: string;
  public birthPlace!: string;
  public nationality!: string;
  public gender: any;
  public nationalId!: string;
  public nationalId2!: string;
  public resellerId!: string;
  public isSystemRequired: any;
  public isPasswordExpired: any;
  public email: any;
  public alternativeEmail: any;
  public phones: any;
  public avatar: any;
  public culture: any;
  public id!: string;
  public isAdministrative: boolean = false;
  public addresses: any;
  public influencerCode!: string;
  public enable2FA: any;

  constructor() {}

  public get AvatarImage(): string {
    if (this.avatar) {
      return this.avatar.avatarImage;
    }
    return '';
  }
}
